import { render, staticRenderFns } from "./Home4.vue?vue&type=template&id=486711ce"
import script from "./Home4.vue?vue&type=script&lang=js"
export * from "./Home4.vue?vue&type=script&lang=js"
import style0 from "./Home4.vue?vue&type=style&index=0&id=486711ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports